export default [
  // 绑车协议
  {
    path: '/binding-agreement',
    component: () => import('../../views/bindingAgreement/Index.vue'),
    name: 'binding-agreement',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
];
